import { FilterAggResultProcessor, FiltersAggResultProcessor, GeoDistanceAggResultProcessor, HistogramAggResultProcessor, RangeAggResultProcessor } from "./index.js";
import TermsAggResultProcessor from "./TermsAggResultProcessor.js";
export default {
  install(molten) {
    molten.addPlugin('AggResultProcessor', {
      type: TermsAggResultProcessor.TYPE,
      process: TermsAggResultProcessor.process
    });
    molten.addPlugin('AggResultProcessor', {
      type: RangeAggResultProcessor.TYPE,
      process: RangeAggResultProcessor.process
    });
    molten.addPlugin('AggResultProcessor', {
      type: GeoDistanceAggResultProcessor.TYPE,
      process: GeoDistanceAggResultProcessor.process
    });
    molten.addPlugin('AggResultProcessor', {
      type: HistogramAggResultProcessor.TYPE,
      process: HistogramAggResultProcessor.process
    });
    molten.addPlugin('AggResultProcessor', {
      type: FilterAggResultProcessor.TYPE,
      process: FilterAggResultProcessor.process
    });
    molten.addPlugin('AggResultProcessor', {
      type: FiltersAggResultProcessor.TYPE,
      process: FiltersAggResultProcessor.process
    });
  }
};